<script>
import {
  pushProductsBlockEmits,
  pushProductsBlockProps,
  usePushProductsBlock
} from "./mixin";
import CarouselSlide from "@/components/organisms/carousel/carousel-slide";
import { productAdditionalDetailsProps } from "@/components/organisms/product-sheet/additional-details/product-additional-details.mixin";
import Carousel from "@/components/organisms/carousel";
import ItemContainer from "@/containers/panier/item";
import Recette from "@/containers/miam/recette";

export default {
  name: "PushProductsBlock",
  inheritAttrs: false,
  components: {
    CarouselSlide,
    ItemContainer,
    Carousel,
    Recette
  },
  props: {
    ...productAdditionalDetailsProps(),
    ...pushProductsBlockProps()
  },
  emits: [...pushProductsBlockEmits()],
  setup(props, context) {
    const carousel = ref(null);
    const ProductListItemGrid = defineAsyncComponent(() =>
      import(
        "@/components/organisms/product-list/product-list-item-grid/default"
      )
    );
    const ProductListItemGridLight = defineAsyncComponent(() =>
      import(
        "@/components/organisms/product-list/product-list-item-grid-light/default"
      )
    );
    const { updated, updateOnce, onIntersect, getDiapoNumber } =
      usePushProductsBlock(props, context, carousel);

    return {
      updated,
      updateOnce,
      onIntersect,
      getDiapoNumber,
      carousel,
      ProductListItemGrid,
      ProductListItemGridLight
    };
  }
};
</script>
<template>
  <div
    class="c-push-products-block"
    :class="[$attrs.class]"
  >
    <Carousel
      ref="carousel"
      :elements-per-slide="$route.name === 'product-sheet' ? 4 :'auto'"
      :slides-offset-before="slidesOffset"
      :slides-offset-after="slidesOffset"
      :navigation-arrows="products.length > 2"
      :free-mode="true"
      :scroll-bar="products.length > 2"
      :aria-labelledby="$attrs['aria-labelledby']"
      @slideChange="updateOnce"
    >
      <template
        v-for="(product, index) in products"
        :key="`push-products-block-${product.id}`"
      >
        <CarouselSlide
          v-if="recetteIndex === index"
          :key="`push-products-block-recette-${product.id}`"
          :separator="productSeparator"
          product-slide
          class="c-push-products-block__slide"
          style="display: none;"
          :diapo-number="recetteIndex+1"
        >
          <Recette
            v-if="produitRecette"
            :product="produitRecette"
            :grid-index="recetteIndex"
            :products="products"
          />
          <Recette
            v-else
            :show-top-recipes="10"
          />
        </CarouselSlide>
        <CarouselSlide
          :separator="productSeparator"
          :class="light ? 'c-push-products-block__slide-light' : 'c-push-products-block__slide'"
          :diapo-number="getDiapoNumber(index)"
        >
          <ItemContainer
            v-intersect="onIntersect"
            :index="index"
            :data-index="index + 1"
            :cart-context="`${label}${label !== trackingCodes.LABELGA.ListePanachages ? trackingCodes.CONTEXTPANIER.PushProduit : ''}${ pushTitle || ''}`"
            :article="product"
            :component="light ? ProductListItemGridLight : ProductListItemGrid"
            :no-border="productSeparator"
            :separator="productSeparator"
            is-carousel-product
            :context="context"
            class="c-push-products-block__item"
          />
        </CarouselSlide>
      </template>
    </Carousel>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/push-products-block";
</style>
